/* eslint-disable */
import { UserLayout, BasicLayout, RouteView } from '@/layouts'

// const RouteView = {
//     name: 'RouteView',
//     render: (h) => h('router-view')
// }

export const asyncRouterMap = [
    {
        path: '/',
        component: BasicLayout,
        meta: {
            title: 'menu.home'
        },
        redirect: '/today',
        children: [
            {
                path: '/index',
                name: 'index',
                redirect: '/today',
                component: RouteView,
                meta: {
                    title: '首页',
                    keepAlive: false,
                    icon: 'home'
                },
                children: [
                    {
                        path: '/today',
                        name: 'today',
                        component: () => import('@/views/dashboard/today'),
                        meta: {
                            title: '今日头条',
                            keepAlive: false
                        }
                    },
                    {
                        path: '/okr',
                        name: 'okr',
                        component: () => import('@/views/dashboard/okr'),
                        meta: {
                            title: 'OKR',
                            keepAlive: false,
                            permission: ['okr']
                        }
                    },
                    {
                        path: '/settings',
                        name: 'sites',
                        component: () => import('@/views/settings/sites'),
                        meta: {
                            title: '网站配置',
                            keepAlive: false,
                            permission: ['sites'],
                            action: {
                                'update': '编辑'
                            }
                        }
                    },
                    {
                        path: '/settings/form',
                        name: 'sites_form',
                        component: () => import('@/views/settings/sites/form'),
                        hidden: true,
                        hideChildrenInMenu: true,
                        meta: {
                            title: '基础设置',
                            keepAlive: false
                        }
                    }
                ]
            },
            // 统计图表
            {
                path: '/charts',
                redirect: '/charts/baidu',
                component: RouteView,
                meta: {
                    title: '统计图表',
                    icon: 'line-chart',
                    permission: ['charts']
                },
                children: [
                    {
                        path: '/charts/baidu',
                        name: 'charts_baidu',
                        component: () => import('@/views/charts/baidu'),
                        meta: {
                            title: '百度统计',
                            keepAlive: false,
                            permission: ['charts_baidu']
                        }
                    },
                    {
                        path: '/charts/order',
                        name: 'charts_order',
                        component: () => import('@/views/charts/order.vue'),
                        meta: {
                            title: '订单统计',
                            keepAlive: false,
                            permission: ['charts_order']
                        }
                    },
                    {
                        path: '/charts/goods',
                        name: 'charts_goods',
                        component: () => import('@/views/charts/goods.vue'),
                        meta: {
                            title: '商品统计',
                            keepAlive: false,
                            permission: ['charts_goods']
                        }
                    }
                ]
            },
            // 课程管理
            {
                path: '/courses_manage',
                redirect: '/courses',
                component: RouteView,
                meta: {
                    title: '课程管理',
                    icon: 'pic-right',
                    permission: ['courses']
                },
                children: [
                    {
                        path: '/courses',
                        name: 'courses',
                        component: () => import('@/views/courses/lists'),
                        meta: {
                            title: '课程列表',
                            keepAlive: false,
                            permission: ['courses_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/courses/categories',
                        name: 'courses_categories',
                        component: () => import('@/views/courses/categories'),
                        meta: {
                            title: '课程分类',
                            keepAlive: false,
                            permission: ['courses_categories'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/courses/form/:id?',
                        name: 'courses_form',
                        component: () => import('@/views/courses/lists/form'),
                        hidden: true,
                        meta: {
                            title: '课程表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/courses/packs',
                        name: 'courses_packs',
                        component: () => import('@/views/courses/packs'),
                        meta: {
                            title: '套购管理',
                            keepAlive: false,
                            permission: ['courses_packs'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/courses/packs/form/:id?',
                        name: 'packs_form',
                        component: () => import('@/views/courses/packs/form'),
                        hidden: true,
                        meta: {
                            title: '套购表单',
                            keepAlive: false,
                        }
                    }
                ]
            },
            
            //证书管理
            {
                path: '/crts_manage',
                redirect: '/certificates',
                component: RouteView,
                meta: {
                    title: '证书管理',
                    icon: 'trophy',
                    permission: ['certificates_manage']
                },
                children: [
                    {
                        path: '/certificates/codes',
                        name: 'code',
                        component: () => import('@/views/certificates/codes'),
                        meta: {
                            title: '考试码管理',
                            keepAlive: false,
                            permission: ['crts_codes'],
                            action: {
                                'delete': '删除',
                                'translate': '转移',
                                'import': '导入',
                                'export': '导出'
                            }
                        }
                    },
                    {
                        path: '/certificates/modes',
                        name: 'crts_modes',
                        component: () => import('@/views/certificates/modes'),
                        meta: {
                            title: '考试类型',
                            keepAlive: false,
                            permission: ['crts_modes'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/certificates/categories',
                        name: 'crts_categories',
                        component: () => import('@/views/certificates/categories'),
                        meta: {
                            title: '证书分类',
                            keepAlive: false,
                            permission: ['crts_categories'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑'
                            }
                        }
                    },
                    {
                        path: '/certificates',
                        name: 'certificates',
                        component: () => import('@/views/certificates/lists'),
                        meta: {
                            title: '证书列表',
                            keepAlive: false,
                            permission: ['crts_lists'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/certificates/form/:id?',
                        name: 'crts_form',
                        component: () => import('@/views/certificates/lists/form'),
                        hidden: true,
                        meta: {
                            title: '证书表单',
                            keepAlive: false,
                        }
                    }
                ]
            },
            // 题库管理
            {
                path: '/exams_manage',
                redirect: '/exams',
                component: RouteView,
                meta: {
                    title: '问卷管理',
                    icon: 'copy',
                    permission: ['exams_manage']
                },
                children: [
                    {
                        path: '/exams',
                        name: 'exams',
                        component: () => import('@/views/exams/index'),
                        meta: {
                            title: '问卷列表',
                            keepAlive: false,
                            permission: ['exams'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                                'contents': '题库管理',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/exams/form/:id?',
                        name: 'exams_form',
                        component: () => import('@/views/exams/form'),
                        hidden: true,
                        meta: {
                            title: '问卷表单',
                            keepAlive: false, 
                        }
                    },
                    {
                        path: '/exams/contents/:id',
                        name: 'exams_contents',
                        component: () => import('@/views/exams/contents'),
                        hidden: true,
                        meta: {
                            title: '题库管理',
                            keepAlive: false, 
                            permission: ['exams_contents'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                            }
                        }
                    }
                ]
            },
            // finance
            {
                path: '/finances',
                redirect: '/finances/invoices',
                component: RouteView,
                meta: {
                    title: '财务管理',
                    icon: 'bank',
                    permission: ['finances']
                },
                children: [
                    {
                        path: '/finances/invoices',
                        name: 'invoices',
                        component: () => import('@/views/finances/invoices/index'),
                        meta: {
                            title: '发票管理',
                            keepAlive: false,
                            permission: ['invoices'],
                            action: {
                                'express': '填写快递',
                                'state': '申请开票',
                                'export': '导出'
                            }
                        }
                    },
                    {
                        path: '/finances/orders',
                        name: 'orders',
                        component: () => import('@/views/finances/orders/index'),
                        meta: {
                            title: '订单管理',
                            keepAlive: false,
                            permission: ['orders'],
                            action: {
                                'state': '订单状态',
                                'export': '导出'
                            }
                        }
                    },
                    {
                        path: '/finances/goods',
                        name: 'goods',
                        component: () => import('@/views/finances/goods/index'),
                        meta: {
                            title: '商品管理',
                            keepAlive: false,
                            permission: ['goods'],
                            action: {
                                'export': '导出'
                            }
                        }
                    },
                    {
                        path: '/finances/baidu',
                        name: 'baidu',
                        component: () => import('@/views/finances/baidu/index'),
                        meta: {
                            title: '百度证书考试数据',
                            keepAlive: false,
                            permission: ['lms'],
                            action: {
                                'export': '导出'
                            }
                        }
                    }
                ]
            },
            // CRM管理
            {
                path: '/customers',
                redirect: '/customers',
                component: RouteView,
                meta: {
                    title: 'CRM管理',
                    icon: 'bar-chart',
                    permission: ['customers']
                },
                children: [
                    {
                        path: '/customers',
                        name: 'customers',
                        component: () => import('@/views/customers/lists/'),
                        meta: {
                            title: '客户管理',
                            keepAlive: false,
                            permission: ['customers_list'],
                            action: {
                                'add': '新建',
                                'update': '编辑'
                            }
                        }
                    },
                    {
                        path: '/customers/form/:id?',
                        name: 'customers_form',
                        component: () => import('@/views/customers/lists/form'),
                        hidden: true,
                        meta: {
                            title: '客户表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/customers/contracts',
                        name: 'contracts',
                        component: () => import('@/views/customers/contracts/index'),
                        meta: {
                            title: '合同管理',
                            keepAlive: false,
                            permission: ['customer_contract'],
                            action: {
                                'add': '新建',
                                'update': '编辑',
                                'delete': '删除'
                            }
                        }
                    },
                    {
                        path: '/customers/contracts/form/:id?',
                        name: 'customer_contracts_form',
                        component: () => import('@/views/customers/contracts/form'),
                        hidden: true,
                        meta: {
                            title: '合同表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/customers/incomes',
                        name: 'money',
                        component: () => import('@/views/customers/incomes'),
                        meta: {
                            title: '收支管理',
                            keepAlive: false,
                            permission: ['customer_money'],
                            action: {
                                'add': '新建',
                                'update': '编辑',
                                'delete': '删除'
                            }
                        }
                    },
                    {
                        path: '/customers/incomes/form/:id?',
                        name: 'customer_money_form',
                        component: () => import('@/views/customers/incomes/form'),
                        hidden: true,
                        meta: {
                            title: '收支表单',
                            keepAlive: false,
                        }
                    },
                ]
            },
            // 优惠码管理
            {
                path: '/coupons',
                redirect: '/coupons',
                component: RouteView,
                meta: {
                    title: '优惠码管理',
                    icon: 'tags',
                    permission: ['coupons']
                },
                children: [
                    {
                        path: '/coupons',
                        name: 'coupons',
                        component: () => import('@/views/coupons'),
                        meta: {
                            title: '优惠码列表',
                            keepAlive: false,
                            permission: ['coupons_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态',
                                'export': '导出'
                            }
                        }
                    },
                    {
                        path: '/coupons/form',
                        name: 'couponsForm',
                        component: () => import('@/views/coupons/form'),
                        hidden: true,
                        meta: {
                            title: '优惠码表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/coupons/edit/:id?',
                        name: 'couponsForm',
                        component: () => import('@/views/coupons/edit'),
                        hidden: true,
                        meta: {
                            title: '优惠码编辑',
                            keepAlive: false,
                        }
                    }
                ]
            },
            // news
            {
                path: '/news/lists',
                redirect: '/news',
                component: RouteView,
                meta: {
                    title: '新闻中心',
                    icon: 'snippets',
                    permission: ['news']
                },
                children: [
                    {
                        path: '/news',
                        name: 'NewsList',
                        component: () => import('@/views/news/lists/index'),
                        meta: {
                            title: '新闻管理',
                            keepAlive: false,
                            permission: ['news_list'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/news/form/:id?',
                        name: 'NewsForm',
                        component: () => import('@/views/news/lists/form'),
                        hidden: true,
                        meta: {
                            title: '新闻表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/news/categories',
                        name: 'Category',
                        component: () => import('@/views/news/categories/index'),
                        meta: {
                            title: '分类管理',
                            keepAlive: false,
                            permission: ['news_categories'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除'
                            }
                        }
                    }
                ]
            },
            // activities
            {
                path: '/activities',
                redirect: '/activities',
                component: RouteView,
                meta: {
                    title: '活动公告',
                    icon: 'qrcode',
                    permission: ['activities']
                },
                children: [
                    {
                        path: '/activities',
                        name: 'activities',
                        component: () => import('@/views/activities/lists/index'),
                        meta: {
                            title: '活动列表',
                            keepAlive: false,
                            permission: ['activity_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/activities/form/:id?',
                        name: 'ActForm',
                        component: () => import('@/views/activities/lists/form'),
                        hidden: true,
                        meta: {
                            title: '活动表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/activities/discounts',
                        name: 'discounts',
                        component: () => import('@/views/activities/discounts/index'),
                        meta: {
                            title: '打折活动',
                            keepAlive: false,
                            permission: ['discounts_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/activities/discounts/form/:id?',
                        name: 'discountsForm',
                        component: () => import('@/views/activities/discounts/form'),
                        hidden: true,
                        meta: {
                            title: '打折活动表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/activities/price',
                        name: 'price',
                        component: () => import('@/views/activities/price/index'),
                        meta: {
                            title: '价格设置',
                            keepAlive: false,
                            permission: ['price_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/activities/price/form/:id?',
                        name: 'priceForm',
                        component: () => import('@/views/activities/price/form'),
                        hidden: true,
                        meta: {
                            title: '价格设置表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/activities/scholarship',
                        name: 'scholarship',
                        component: () => import('@/views/activities/scholarship/index'),
                        meta: {
                            title: '奖学金计划',
                            keepAlive: false,
                            permission: ['scholarship'],
                            action: {
                                'export': '导出',
                            }
                        }
                    }
                ]
            },

            // ad
            {
                path: '/ads',
                redirect: '/ads',
                component: RouteView,
                meta: {
                    title: '广告管理',
                    icon: 'file-jpg',
                    permission: ['ads']
                },
                children: [
                    {
                        path: '/ads',
                        name: 'adsList',
                        component: () => import('@/views/ads/lists'),
                        meta: {
                            title: '广告列表',
                            keepAlive: false,
                            permission: ['ads_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/ads/places',
                        name: 'places',
                        component: () => import('@/views/ads/places'),
                        meta: {
                            title: '广告位管理',
                            keepAlive: false,
                            permission: ['ads_places'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    }
                ]
            },
            {
                path: '/downloads',
                redirect: '/downloads',
                component: RouteView,
                meta: {
                    title: '下载管理',
                    icon: 'qrcode',
                    permission: ['downloads']
                },
                children: [
                    {
                        path: '/downloads',
                        name: 'downloadsList',
                        component: () => import('@/views/downloads/index'),
                        meta: {
                            title: '下载列表',
                            keepAlive: false,
                            permission: ['downloads_list'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/downloads/form/:id?',
                        name: 'DownloadsForm',
                        component: () => import('@/views/downloads/form'),
                        hidden: true,
                        meta: {
                            title: '下载表单',
                            keepAlive: false,
                        }
                    }
                ]
            },
            {
                path: '/books',
                redirect: '/books',
                component: RouteView,
                meta: {
                    title: '开源图书馆',
                    icon: 'snippets',
                    permission: ['books']
                },
                children: [
                    {
                        path: '/books/authors',
                        name: 'Authors',
                        component: () => import('@/views/books/authors/index'),
                        meta: {
                            title: '作者',
                            keepAlive: false,
                            permission: ['books_authors'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除'
                            }
                        }
                    },
                    {
                        path: '/books/authors/form/:id?',
                        name: 'AuthorForm',
                        component: () => import('@/views/books/authors/form'),
                        hidden: true,
                        meta: {
                            title: '作者表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/books',
                        name: 'BooksList',
                        component: () => import('@/views/books/lists/index'),
                        meta: {
                            title: '图书管理',
                            keepAlive: false,
                            permission: ['books_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'contents': '目录管理',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/books/form/:id?',
                        name: 'BooksForm',
                        component: () => import('@/views/books/lists/form'),
                        hidden: true,
                        meta: {
                            title: '图书表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/books/contents/:id',
                        name: 'BooksContent',
                        component: () => import('@/views/books/lists/contents'),
                        hidden: true,
                        meta: {
                            title: '目录管理',
                            keepAlive: false,
                            permission: ['books_contents'],
                            action: {
                                'catalog': '目录编辑',
                                'content': '内容管理',
                                'delete': '删除',
                            }
                        }
                    }
                ]
            },
            // 视频管理
            {
                path: '/videos',
                redirect: '/videos',
                component: RouteView,
                meta: {
                    title: '视频管理',
                    icon: 'pic-right',
                    permission: ['videos']
                },
                children: [
                    {
                        path: '/videos',
                        name: 'videos',
                        component: () => import('@/views/videos/lists'),
                        meta: {
                            title: '视频列表',
                            keepAlive: false,
                            permission: ['videos_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/videos/form/:id?',
                        name: 'videos_form',
                        component: () => import('@/views/videos/lists/form'),
                        hidden: true,
                        meta: {
                            title: '视频编辑',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/videos/collections/:id',
                        name: 'videos_collections',
                        component: () => import('@/views/videos/collections/index'),
                        hidden: true,
                        meta: {
                            title: '管理目录',
                            keepAlive: false,
                            permission: ['videos_collections'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    }
                ]
            },

            // jobs
            {
                path: '/jobs',
                redirect: '/jobs',
                component: RouteView,
                meta: {
                    title: '招聘管理',
                    icon: 'wallet',
                    permission: ['jobs']
                },
                children: [
                    {
                        path: '/jobs/enterprises',
                        name: 'enterprise',
                        component: () => import('@/views/jobs/enterprises'),
                        meta: {
                            title: '公司列表',
                            keepAlive: false,
                            permission: ['enterprises'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/jobs',
                        name: 'jobs',
                        component: () => import('@/views/jobs/lists'),
                        meta: {
                            title: '职位列表',
                            keepAlive: false,
                            permission: ['jobs_lists'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/jobs/form/:id?',
                        name: 'jobForm',
                        component: () => import('@/views/jobs/lists/form'),
                        hidden: true,
                        meta: {
                            title: '职位表单',
                            keepAlive: false,
                        }
                    }
                ]
            },
            // link
            {
                path: '/links',
                redirect: '/partners/links',
                component: RouteView,
                meta: {
                    title: '合作管理',
                    icon: 'deployment-unit',
                    permission: ['links']
                },
                children: [
                    {
                        path: '/partners/links',
                        name: 'links',
                        component: () => import('@/views/partners/links'),
                        meta: {
                            title: '合作伙伴',
                            keepAlive: false,
                            permission: ['links_list'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/partners/teachers',
                        name: 'teacher',
                        component: () => import('@/views/partners/teachers/index'),
                        meta: {
                            title: 'LFAI/布道者',
                            keepAlive: false,
                            permission: ['teacher_list'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除'
                            }
                        }
                    },
                    {
                        path: '/partners/teachers/form/:id?',
                        name: 'lfaiEdit',
                        hidden: true,
                        component: () => import('@/views/partners/teachers/form'),
                        meta: {
                            title: 'LFAI/开源布道者',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/partners/sig',
                        name: 'sigs',
                        component: () => import('@/views/partners/sigs/index'),
                        meta: {
                            title: 'SIG',
                            keepAlive: false,
                            permission: ['sigs_list'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除'
                            }
                        },
                    },
                    {
                        path: '/partners/sigs/form/:id?',
                        name: 'sigEdit',
                        hidden: true,
                        component: () => import('@/views/partners/sigs/form'),
                        meta: {
                            title: 'SIG',
                            keepAlive: false,
                        }
                    }
                ]
            },
            // 系统设置
            {
                path: '/settings',
                redirect: '/settings/articles',
                component: RouteView,
                meta: {
                    title: '系统设置',
                    icon: 'setting',
                    permission: ['settings']
                },
                children: [
                    {
                        path: '/settings/articles',
                        name: 'articles',
                        component: () => import('@/views/settings/articles/index'),
                        meta: {
                            title: '系统文章',
                            keepAlive: false,
                            permission: ['articles'],
                            action: {
                                'add': '新增',
                                'update': '编辑',
                                'delete': '删除',
                                'state': '修改状态'
                            }
                        }
                    },
                    {
                        path: '/settings/articles/form/:id?',
                        name: 'articles_form',
                        component: () => import('@/views/settings/articles/form'),
                        hidden: true,
                        meta: {
                            title: '文章表单',
                            keepAlive: false,
                        }
                    },
                    {
                        path: '/settings/helps',
                        name: 'settings_helps',
                        component: () => import('@/views/settings/helps'),
                        meta: {
                            title: '帮助中心',
                            keepAlive: false,
                            permission: ['helps_list'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                                'state': '修改状态'
                            }
                        }
                    }
                ]
            },

            // 评论管理
            {
                path: '/comments',
                redirect: '/comments',
                component: RouteView,
                meta: {
                    title: '评论管理',
                    icon: 'appstore',
                    permission: ['comments']
                },
                children: [
                    {
                        path: '/comments',
                        name: 'Comments',
                        component: () => import('@/views/comments'),
                        meta: {
                            title: '评论列表',
                            keepAlive: false,
                            permission: ['comments_list']
                        }
                    }
                ]
            },
            // authority
            {
                path: '/admins',
                redirect: '/admins/users',
                component: RouteView,
                meta: {
                    title: '管理员管理',
                    icon: 'apartment',
                    permission: ['admins']
                },
                children: [
                    {
                        path: '/admins/users',
                        name: 'users',
                        component: () => import('@/views/admins/users'),
                        meta: {
                            title: '管理员列表',
                            keepAlive: false,
                            permission: ['users'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                                'reset': '重置密码'
                            }
                        }
                    },
                    {
                        path: '/admins/roles',
                        name: 'Roles',
                        component: () => import('@/views/admins/roles/index'),
                        meta: {
                            title: '角色管理',
                            keepAlive: false,
                            permission: ['roles'],
                            action: {
                                'delete': '删除',
                                'add': '新增',
                                'update': '编辑',
                            }
                        }
                    },
                    {
                        path: '/admins/roles/form/:id?',
                        name: 'roles_form',
                        component: () => import('@/views/admins/roles/form'),
                        hidden: true,
                        meta: {
                            title: '角色表单',
                            keepAlive: false,
                        }
                    }
                ]
            },
            // member
            {
                path: '/members',
                redirect: '/members',
                component: RouteView,
                meta: {
                    title: '用户管理',
                    icon: 'team',
                    permission: ['members']
                },
                children: [
                    {
                        path: '/members',
                        name: 'members',
                        component: () => import('@/views/members'),
                        meta: {
                            title: '用户列表',
                            keepAlive: false,
                            permission: ['members_list'],
                            action: {
                                'real': '认证',
                                'state': '修改状态',
                                'export': '导出'
                            }
                        }
                    }
                ]
            },

            // account
            {
                path: '/account',
                component: RouteView,
                redirect: '/account/center',
                name: 'account',
                meta: {
                    title: '个人中心',
                    icon: 'user',
                    keepAlive: false,
                    permission: ['account']
                },
                children: [
                    {
                        path: '/admins/account',
                        name: 'center',
                        component: () => import('@/views/admins/account'),
                        meta: {
                            title: '个人设置',
                            keepAlive: false,
                            permission: ['user'],
                            action: {
                                'update': '编辑'
                            }
                        }
                    },
                    {
                        path: '/admins/loginlogs',
                        name: 'loginlogs',
                        component: () => import('@/views/admins/loginlogs'),
                        meta: {
                            title: '登录日志',
                            keepAlive: false,
                            permission: ['loginlogs']
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
    {
        path: '/user',
        component: UserLayout,
        redirect: '/user/login',
        hidden: true,
        children: [
            {
                path: 'login',
                name: 'login',
                component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
                meta: {
                    title: '登录'
                }
            }
        ]
    },
    {
        path: '/404',
        component: () => import( /* webpackChunkName: "fail" */ '@/views/exception/404')
    }
    
]